import {Component, OnInit, ViewChild} from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  faqs: any[] = [
    {
      q: '1. How the dashboard is going to help you in your business?',
      ans: `
        <div class="container">
        <p>a) The dashboard is going to help you to understand & forecast the demand of automotive parts and consumables before the service. This further helps you improve your service delivery time & eases the entire procurement process.  </p>
        <p> </p>
        <p>b) The dashboard enables you to send reminders for PUC, RC and Insurance Renewal. These reminders would be a value added service to your customers </p>
        <p>via which you will help them save on various penalties due to delay in renewal of various car related documents.  </p>
        <p> </p>
        <p>c) It helps you understand when your customer’s car needs servicing, basis which you can send your customers customized reminders and offers.  </p>
        <p> </p>
        <p>d) It monitors your customer’s car health & performance basis which you help your customers to prevent any unexpected car breakdown and also can help your customers to save on car maintenance costs/needs.  </p>
        <p> </p>
        <p>e) It sends driving alerts to your customers which further ensures your customers safety on the roads.  </p>
        <p> </p>
        <p>f) It enables you to keep a track of Overall functions of Several branches of garages as a Super admin. </p>
        </div>`
    }, {
      q: '2. How to manage customers with Gypsee?',
      ans: 'You can manage your customers way better with Gypsee Dashboard as you can predict the future problems associated with your customers\' cars and can also inform them the same to ensure the right measures are taken at the right time to minimize the cost.'
    },
    {
      q: '3. Are you facing issues in “Procurement of Automotive parts and consumables” for your customers?',
      'ans': ' If yes then it wouldn’t be the same once you have got Gypsee to save your back.  Because Gypsee keeps you updated about your customers car health & condition. So you are often aware of the car condition and in the state to understand, analyze and predict the upcoming requirements. Basis which you can plan & procure the automotive parts and consumables. '
    },
    {
      q: '4. Things which gets better with Gypsee',
      ans: `
        <div class="container">
        <p>a) You can help your customers to save on car maintenance costs/needs. </p>
        <p>b) You can reduce your service delivery time & enhance your customer experience.  </p>
        <p>c) You can ensure your customers & their loved ones safety on the roads.  </p>
        <p>d) You can help your customers save on various penalties.  </p>
        </div>`
    },
    {
      q: '5. What is a Trouble code?',
      ans: `
          <div class="container">
          <p>DTC (diagnostic trouble codes), also known as OBDII codes, are your car’s system for alerting you of vehicle issues. There are typically limits for each system within your vehicle. When the vehicle detects that the issue exceeds these limits, it sends out a trouble code. Technicians use these codes to diagnose and repair vehicle issues. </p>
          <p> </p>
          <strong class="text-success">The Four Systems of DTC </strong>
          <p> </p>
          <p>A. B-codes (body codes): Though body often refers to the outside of the vehicle, B-codes refer to features inside. More include comfort, convenience, and safety features. </p>
          <p>B. C-codes (chassis): Functions outside of the passenger compartment including brakes, steering, and suspension. </p>
          <p>C. U-codes (network/vehicle integration): Functions shared among the vehicle’s systems and computers. </p>
          <p>D. P-codes (powertrain): Include functions such as the engine, transmission, and drivetrain. </p>
          </div>`
    }, {
      q: '6. How will the Reminder feature  help you in Providing the best services to your customers?',
      ans: 'It’s so simple, with Gypsee reminder features your customers will have more preventive maintenance pays and less corrective maintenance pays as they will be reminded of every problem. As we all know that prevention is often better than cure and it often costs less than the cure as well. So it’s so clear that Gypsee will help your customers to save thousands of rupees on car maintenance, safety & penalty aspects. \n'
    }
  ];

  panelOpenState = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
